import React from 'react';

import { LucideIcon } from 'lucide-react';

import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

interface EmptyStateProps {
  /**
   * Icon to display in the empty state
   */
  icon?: LucideIcon;
  /**
   * Title text for the empty state
   */
  title: string;
  /**
   * Description text for the empty state
   */
  description: string;
  /**
   * Optional action buttons to display below the description
   */
  actions?: React.ReactNode;
  /**
   * Optional additional content to display
   */
  children?: React.ReactNode;
}

/**
 * Reusable empty state component for displaying messages when content is unavailable
 * Uses shadcn/ui Empty component for consistent styling
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  actions,
  children,
}) => {
  return (
    <Empty>
      <EmptyHeader>
        {Icon && (
          <EmptyMedia variant="icon">
            <Icon />
          </EmptyMedia>
        )}
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      {(actions || children) && (
        <EmptyContent>
          {actions}
          {children}
        </EmptyContent>
      )}
    </Empty>
  );
};
